import { Box, Checkbox, FormControlLabel, Radio, RadioGroup, FormLabel, FormControl, Breadcrumbs, Button, Grid, Tab, Table, TableBody, TableContainer, TableHead, Tabs, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { currencyOptions, POTypeOptions, useCommonStyles } from '../../utils';
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import CommonTextField from '../Common/CommonTextField';
import ErrorHandler from '../../lib/errorHandler';
import CommonDatePicker from '../Common/CommonDatePicker';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import { InventoryTypeInum } from '../../lib/enum';
import CommonLabel from '../Common/CommonLabel';
import { addInvoice, getCustomers, getInvoiceItemList, updateInvoice } from '../../Redux/Actions/Invoice';
import { getInventoryFields } from '../../Redux/Actions/Inventory';
import IconBackground from '../Common/IconBackground';
import dayjs from 'dayjs';
import ErrorMessage from '../Common/ErrorMessage';
import { isCompleteDate } from '../../lib/standardDateFormat';
import { getAdvancelicenseNumber } from '../../Redux/Actions/PurchaseEntry';

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        margin: "30px",
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            backgroundColor: "transparent",
            alignItems: "start",
            color: "#555151",
            fontFamily: "Satoshi-Light",
            minWidth: "0px",
            fontSize: "18px"
        },
        "& .Mui-selected": {
            fontFamily: "Satoshi-Bold",
            color: theme.palette.primary.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}))

const invoiceStep = [
    { name: "Basic Details", value: 0, },
    { name: "Add Items", value: 1, },
    { name: "Other Details", value: 2, },
];

const AddUpdateInvoice = ({ setIsOpenAddUpdateInvoice, setInvoiceData, invoiceData, purchaseOrderListData, setPurchaseOrderListData, _getListData, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    // ============== States ==============
    const [errors, setErrors] = useState({});
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Basic Details", value: 0 });

    const [customerNamePage, setCustomerNamePage] = useState(1);
    const [customerNametotalCount, setCustomerNameTotalCount] = useState();
    const [customerNameList, setCustomerNameList] = useState([]);
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [searchCustomerName, setSearchCustomerName] = useState();

    const [allItemsPage, setAllItemsPage] = useState(1);
    const [allItemsTotalCount, setAllItemsTotalCount] = useState();
    const [allItemsList, setAllItemsList] = useState([]);
    const [allItemsOptions, setAllItemsOptions] = useState([]);
    const [searchAllItems, setSearchAllItems] = useState();

    const [unitPage, setUnitPage] = useState(1);
    const [unitTotalCount, setUnitTotalCount] = useState();
    const [unitList, setUnitList] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [searchUnit, setSearchUnit] = useState();
    const [advanceLicenseNoList, setAdvanceLicenseNoList] = useState([]);
    const [isAdvanceLicense, setIsAdvanceLicense] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    // ============== Handler ==============
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdateInvoice(false); setInvoiceData({}); setPurchaseOrderListData([]); setSearchValue("") }}>
            Invoice
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {"Create Invoice"}
        </Typography>,
    ];
    const handleUpdatePreviousValue = () => {
        const temp = invoiceStep?.find((ele) => ele?.value == value - 1)
        setValue(value - 1)
        setActiveTab(temp)
    }


    // console.log(selectedRows, "selectedRows")

    // console.log(allItemsList, "allItemsList")
    // console.log(purchaseOrderListData, "purchaseOrderListData")

    const handleRowSelect = (row, index) => {
        setSelectedRows((prev) => {
            const exists = prev.find((item) => item.index === index);
            if (exists) {
                // remove if already selected
                return prev.filter((item) => item.index !== index);
            } else {
                // add with extra fields
                return [
                    ...prev,
                    {
                        ...row,
                        index,
                        advanceLicenseQuantity: null,
                        advanceLicensePrice: null,
                    },
                ];
            }
        });
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // select all rows with extra fields
            const all = purchaseOrderListData.map((row, index) => ({
                ...row,
                index,
                advanceLicenseQuantity: null,
                advanceLicensePrice: null,
            }));
            setSelectedRows(all);
        } else {
            // deselect all
            setSelectedRows([]);
        }
    };

    const handleAdvanceLicenseChange = (index, { quantity, rate }) => {
        setSelectedRows((prev) =>
            prev.map((item) => {
                if (item.index === index) {
                    const newQty = quantity !== undefined ? Number(quantity) : item.advanceLicenseQuantity || 0;
                    const newRate = rate !== undefined ? Number(rate) : item.ratePerUnit || 0;
                    return {
                        ...item,
                        advanceLicenseQuantity: newQty,
                        ratePerUnit: newRate, // update rate if provided
                        advanceLicensePrice: newQty * newRate,
                    };
                }
                return item;
            })
        );
    };


    const handleUpdateNextValue = () => {
        if (validStep()) {
            const temp = invoiceStep?.find((ele) => ele?.value == value + 1)
            if (temp) {
                setValue(value + 1)
                setActiveTab(temp)
            } else {
                _addInvoice();
            }
        }
    }

    const _getAdvanceLicense = async () => {
        try {
            const response = await dispatch(getAdvancelicenseNumber());
            setAdvanceLicenseNoList(response?.payload?.data?.document);
        } catch (error) {
            console.error("Error fetching Advance License:", error);
        }
    };

    // console.log("advance license", advanceLicenseNoList);
    // console.log("invoice Data", invoiceData);
    // console.log("is advance lisense", isAdvanceLicense);
    // console.log("selected Rows", selectedRows)
    useEffect(() => {
        if (invoiceData?.vendorType?.id == 2) {
            _getAdvanceLicense();
        }
    }, [invoiceData]);
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const handleChange = (name, value) => {
        setInvoiceData({ ...invoiceData, [name]: value })
    }

    const createItemList = () => {
        if (invoiceData?.allItems) {
            const newItem = {
                itemName: invoiceData.allItems.name,
                id: invoiceData.allItems._id,
                quantity: "",
                ratePerUnit: '',
                subTotal: "",
            };
            const isItemExists = purchaseOrderListData.some((order) => order.itemName === newItem.itemName);
            if (isItemExists) {
                setSnackBar("error", "Item already exists.");
            } else {
                setPurchaseOrderListData(prevData => [...prevData, newItem]);
                setInvoiceData({ ...invoiceData, allItems: "" })
            }
        } else {
            setSnackBar("error", "Please select an item.");
        }
    };


    const handleChangeForItems = (index, value, name) => {
        const updatedData = purchaseOrderListData?.map((ele, i) =>
            i === index ? { ...ele, [name]: value, subTotal: name == "ratePerUnit" ? value * ele?.quantity : ele?.ratePerUnit * value } : ele
        );
        const totalQuantity = updatedData.reduce((acc, row) => acc + (Number(row?.quantity) || 0), 0);
        const subTotal = updatedData.reduce((acc, row) => acc + (Number(row?.subTotal) || 0), 0);
        setPurchaseOrderListData(updatedData);
        setInvoiceData({ ...invoiceData, totalQuantity, subTotal });
    };

    const handleDeleteItem = (i) => {
        const updatedData = purchaseOrderListData?.filter((ele, index) => index !== i)
        setPurchaseOrderListData(updatedData);
    }

    //------------------  Unit API ------------------
    const _getUnit = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Unit"],
            "limit": 10,
            "page": p ? p : unitPage
        };
        response = await dispatch(getInventoryFields(body));
        { (unitList?.length !== unitTotalCount) && setUnitPage(unitPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchUnit(searchText ? searchText : "");
            setUnitTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setUnitList([...unitList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForUnit = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Unit"],
            "limit": 10,
            "page": p
        };
        response = await dispatch(getInventoryFields(body));
        setUnitPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchUnit(searchText);
            setUnitList(response?.payload?.data?.response);
        }
    };

    //------------------  Customer Name API ------------------
    const _getCustomerName = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : customerNamePage
        }
        response = await dispatch(getCustomers(body));
        { (customerNameList?.length !== customerNametotalCount) && setCustomerNamePage(customerNamePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCustomerName(searchText ? searchText : "");
            setCustomerNameTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setCustomerNameList([...customerNameList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForCustomerName = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p
        }
        response = await dispatch(getCustomers(body));
        setCustomerNamePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCustomerName(searchText);
            setCustomerNameList(response?.payload?.data?.response);
        }
    };

    //------------------  Group API ------------------
    const _getAllItems = async (p, searchText) => {
        let response;
        let body;
        body = {
            "limit": 10,
            "page": p ? p : allItemsPage
        }
        response = await dispatch(getInvoiceItemList(body));
        { (allItemsList?.length !== allItemsTotalCount) && setAllItemsPage(allItemsPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText ? searchText : "");
            setAllItemsTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setAllItemsList([...allItemsList, ...response?.payload?.data?.response]);
            }
        }
    };



    const handleChangeInputForAllItems = async (p, searchText) => {
        let response;
        let body;
        body = {
            "limit": 10,
            "page": p
        }
        response = await dispatch(getInvoiceItemList(body));
        setAllItemsPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText);
            setAllItemsList(response?.payload?.data?.response);
        }
    };


    const validStep = () => {
        let formIsValid = true;
        let errors = {}
        const isAnyItemAnsRemain = purchaseOrderListData?.some((ele) => ele?.quantity == "" || ele?.ratePerUnit == "")
        if (activeTab?.value == 0) {
            if (!invoiceData?.invoiceNumber) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please enter invoice number." : "Please enter invoice number in basic details.")
            }
            if (!invoiceData?.invoiceDate) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select invoice date." : "Please select invoice date in basic details.")
            }
            if (invoiceData?.invoiceDate) {
                if (!isCompleteDate(invoiceData?.invoiceDate)) {
                    formIsValid = false;
                    setSnackBar("error", activeTab?.value == 0 ? "Please select valid invoice date" : "Please select valid invoice date in basic details.")
                }
            }
            if (!invoiceData?.vendorType) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select invoice type." : "Please select invoice type in basic details.")
            }
            if (!invoiceData?.customerName?.contactPersonDetail?.firstName) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select customer name." : "Please select customer name in basic details.")
            }
            if (isAdvanceLicense == true && !invoiceData?.advanceLicenseId) {
                formIsValid = false
                setSnackBar("error", "select advance license.")
            }
        } else if (activeTab?.value == 1) {
            if (purchaseOrderListData?.length == 0) {
                formIsValid = false;
                setSnackBar("error", "Please select item.")
            } else if (isAnyItemAnsRemain) {
                formIsValid = false;
                setSnackBar("error", "Please enter quantity and rate per unit for all item.")
            }
            if (!invoiceData?.currency) {
                formIsValid = false;
                setSnackBar("error", "Please select currency.")
            }
            if (!invoiceData?.unit) {
                formIsValid = false;
                setSnackBar("error", "Please select unit.")
            }
        } else {
            if (!invoiceData?.invoiceNumber) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please enter invoice number." : "Please enter invoice number in basic details.")
            } else if (purchaseOrderListData?.length == 0) {
                formIsValid = false;
                setSnackBar("error", "Please select item.")
            } else if (isAnyItemAnsRemain) {
                formIsValid = false;
                setSnackBar("error", "Please enter quantity and rate per unit for all item.")
            }
            if (!invoiceData?.currency) {
                formIsValid = false;
                setSnackBar("error", "Please select currency in add item.")
            }
            if (!invoiceData?.unit) {
                formIsValid = false;
                setSnackBar("error", "Please select unit in add item")
            }
            if (!invoiceData?.invoiceDate) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select invoice date." : "Please select invoice date in basic details.")
            }
            if (invoiceData?.invoiceDate) {
                if (!isCompleteDate(invoiceData?.invoiceDate)) {
                    formIsValid = false;
                    setSnackBar("error", activeTab?.value == 0 ? "Please select valid invoice date" : "Please select valid invoice date in basic details.")
                }
            }
            if (!invoiceData?.vendorType) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select invoice type." : "Please select invoice type in basic details.")
            }
            if (!invoiceData?.customerName?.contactPersonDetail?.firstName) {
                formIsValid = false
                setSnackBar("error", activeTab?.value == 0 ? "Please select customer name." : "Please select customer name in basic details.")
            }
        }
        setErrors(errors)
        return formIsValid;
    }
    // ============= add Invoice API =============
    const _addInvoice = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "invoiceNumber": invoiceData?.invoiceNumber,
                "invoiceDate": invoiceData.invoiceDate ? dayjs(invoiceData.invoiceDate).format("YYYY-MM-DD") : null,
                "invoice_type": Number(invoiceData?.vendorType?.id),
                "customer_name": invoiceData?.customerName?.contactPersonDetail?.firstName,
                "purchaseOrder": purchaseOrderListData,
                "moneyType": invoiceData?.currency?.name,
                "totalAmount": invoiceData?.subTotal,
                "totalQuantity": invoiceData?.totalQuantity,
                "packing_charge": invoiceData?.packingCharge,
                "insurance": invoiceData?.Insurance,
                "other_charge": invoiceData?.otherCharge,
                "customerDetails": invoiceData?.customerDetails,
                "unitType": invoiceData?.unit?.unit,
                "advanceLicenseItems": selectedRows,
                "advanceLicenseId": invoiceData?.advanceLicenseId
            }
            response = await dispatch(addInvoice(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setIsOpenAddUpdateInvoice(false);
                    setPurchaseOrderListData([]);
                    setInvoiceData({ currency: { name: "INR", symbol: "₹" } });
                    _getListData();
                    setSearchValue('')
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    }

    // console.log(purchaseOrderListData, "purchaseOrderListData")

    // ============== Use State ==============
    useEffect(() => {
        setCustomerNameOptions(customerNameList?.map((e) => e));
    }, [customerNameList]);

    useEffect(() => {
        setAllItemsOptions(allItemsList?.map((e) => e));
    }, [allItemsList]);

    useEffect(() => {
        setUnitOptions(unitList?.map((e) => e));
    }, [unitList]);

    useEffect(() => {
        _getCustomerName();
        _getAllItems();
        _getUnit();
    }, []);

    return (
        <Box display={"flex"}>
            <Box sx={{ minWidth: "275px", height: "calc(100vh - 84px)", backgroundColor: "#E2E4F8" }}>
                <Tabs value={value} onChange={handleChangeTab} className={muiClasses.customTabStyle}
                    orientation="vertical">
                    {invoiceStep.map((ele, index) => (
                        <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                    ))}
                </Tabs>
            </Box>
            <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
                <Grid item xs={12}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>  {"Create Invoice"}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px", maxHeight: "64vh", overflowY: "auto" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>{activeTab.name}</Typography>
                            </Grid>
                            {activeTab?.value == 0 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            valid
                                            label="Invoice Number"
                                            name="invoiceNumber"
                                            value={invoiceData?.invoiceNumber}
                                            placeholder="Enter The Invoice Number"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("invoiceNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonDatePicker
                                            valid
                                            label="Invoice Date"
                                            onChange={(value) => handleChange("invoiceDate", value)}
                                            value={invoiceData?.invoiceDate || null}
                                            name="invoiceDate"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            valid
                                            label="Local / export"
                                            placeholder="Select Vendor Type"
                                            options={POTypeOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={invoiceData?.vendorType || null}
                                            onChange={(e, newValue) => handleChange("vendorType", newValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            valid
                                            label="Customer Name"
                                            placeholder="Select Customer Name"
                                            options={customerNameOptions || []}
                                            getOptionLabel={(option) => option?.contactPersonDetail?.firstName || ""}
                                            value={invoiceData?.customerName || null}
                                            onChange={(e, newValue) => handleChange("customerName", newValue)}
                                            loadData={(customerNameOptions?.length !== customerNametotalCount) ? _getCustomerName : undefined}
                                            handleSearch={(e) => handleChangeInputForCustomerName(1, e?.target?.value)}
                                            searchValue={searchCustomerName}
                                        />
                                    </Grid>
                                    {invoiceData?.vendorType?.id == 2 && <Grid item xs={12} sm={6} md={4} >
                                        <FormControl component="fieldset">
                                            <FormLabel sx={{
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                fontFamily: "Satoshi-Medium",
                                                color: "#2E2E30",
                                                marginBottom: "8px",
                                                textTransform: "capitalize",
                                            }}>Advance License</FormLabel>
                                            <RadioGroup
                                                row
                                                name="advanceLicense"
                                                value={isAdvanceLicense ? "yes" : "no"}
                                                onChange={(e) => setIsAdvanceLicense(e.target.value === "yes")}
                                            >
                                                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="no" control={<Radio />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>}
                                    {
                                        isAdvanceLicense && invoiceData?.vendorType?.id == 2 &&
                                        <Grid item xs={12} sm={6} md={4} >
                                            <CommonAutoComplete
                                                valid
                                                label="Advance License Number"
                                                placeholder="Select Advance License Number"
                                                options={advanceLicenseNoList || []}
                                                getOptionLabel={(option) => option?.advanceLicenseNo || ""}
                                                onChange={(e, newValue) =>
                                                    handleChange("advanceLicenseId", newValue?._id || null)
                                                }
                                            />
                                            <ErrorMessage text={errors.advanceLicenseId || ""} />
                                        </Grid>
                                    }
                                </>
                            }
                            {activeTab?.value == 1 &&
                                <>
                                    <Grid item xs={6} sm={8} md={9} lg={9} xl={10} >
                                        <CommonAutoComplete
                                            label="All Items"
                                            placeholder="Select Item"
                                            options={allItemsOptions || []}
                                            // getOptionLabel={(option) => option || ""}
                                            value={invoiceData?.allItems || null}
                                            onChange={(e, newValue) => handleChange("allItems", newValue)}
                                            loadData={(allItemsOptions?.length !== allItemsTotalCount) ? _getAllItems : undefined}
                                            handleSearch={(e) => handleChangeInputForAllItems(1, e?.target?.value)}
                                            searchValue={searchAllItems}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={3} xl={2} alignSelf={"end"} >
                                        <Button variant='outlined' onClick={() => createItemList()} sx={{ borderRadius: "10px", backgroundColor: "#FFF", padding: "7px 1rem", "&:hover": { backgroundColor: "#FFF" }, }} startIcon={<AddCircleIcon />}>Add items</Button>
                                    </Grid>
                                    <Grid item xs={12} width={"100px"}>
                                        <CommonLabel title={'Purchase Order'} />
                                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <StyledTableRow isHeader isBordered style={{ backgroundColor: "#E9E9E9" }}>
                                                            {isAdvanceLicense && (
                                                                <StyledTableCell align="center">
                                                                    <Checkbox
                                                                        checked={
                                                                            purchaseOrderListData.length > 0 &&
                                                                            selectedRows.length === purchaseOrderListData.length
                                                                        } // ✅ checked only if all rows selected
                                                                        indeterminate={
                                                                            selectedRows.length > 0 &&
                                                                            selectedRows.length < purchaseOrderListData.length
                                                                        } // ✅ half-checked if some selected
                                                                        onChange={handleSelectAll}
                                                                    />
                                                                </StyledTableCell>
                                                            )}

                                                            <StyledTableCell align='center'>Item(s)</StyledTableCell>
                                                            <StyledTableCell align='center'>Quantity</StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                    {"Unit"}
                                                                    <CommonAutoComplete
                                                                        placeholder="Select Unit"
                                                                        width={"100px"}
                                                                        clearIcon={false}
                                                                        options={unitOptions || []}
                                                                        getOptionLabel={(option) => option?.unit || ""}
                                                                        value={invoiceData?.unit || null}
                                                                        onChange={(e, newValue) => setInvoiceData({ ...invoiceData, unit: newValue })}
                                                                        loadData={(unitOptions?.length !== unitTotalCount) ? _getUnit : undefined}
                                                                        handleSearch={(e) => handleChangeInputForUnit(1, e?.target?.value)}
                                                                        searchValue={searchUnit}
                                                                        optionsMargin={0.8}
                                                                        sx={{
                                                                            "& .MuiOutlinedInput-root": { py: "4px !important", borderRadius: "30px", paddingRight: "25px !important" },
                                                                            "& .MuiAutocomplete-endAdornment": { right: "0px !important" },
                                                                            // "&.MuiOutlinedInput-root": { paddingRight: "25px" }
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                                                    {"Rate per Unit"}
                                                                    <CommonAutoComplete
                                                                        width={"60px"}
                                                                        clearIcon={false}
                                                                        placeholder="Select Production Month"
                                                                        options={currencyOptions || []}
                                                                        getOptionLabel={(option) => option?.name || ""}
                                                                        value={invoiceData?.currency || null}
                                                                        onChange={(e, newValue) => setInvoiceData({ ...invoiceData, currency: newValue })}
                                                                        optionsMargin={0.8}
                                                                        sx={{
                                                                            "& .MuiOutlinedInput-root": { py: "4px !important", borderRadius: "30px" },
                                                                            "& .MuiAutocomplete-endAdornment": { right: "0px !important" }
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </StyledTableCell>
                                                            <StyledTableCell align='center'>
                                                                {"Subtotal"}
                                                            </StyledTableCell>
                                                            <StyledTableCell align='center'>Delete</StyledTableCell>
                                                            {isAdvanceLicense && <StyledTableCell align='center'>Advance License quantity</StyledTableCell>}
                                                            {isAdvanceLicense && <StyledTableCell align='center'>Advance License rate</StyledTableCell>}
                                                        </StyledTableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {purchaseOrderListData?.length > 0 ?
                                                            <>
                                                                {purchaseOrderListData?.map((row, index) => {
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            <StyledTableRow noColor isBordered>
                                                                                {isAdvanceLicense && <StyledTableCell isBordered>
                                                                                    <Checkbox
                                                                                        checked={selectedRows.some(item => item.index === index)} // checked if this row is selected
                                                                                        onChange={() => handleRowSelect(row, index)}
                                                                                    />
                                                                                </StyledTableCell>}
                                                                                <StyledTableCell isBordered >
                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{row?.itemName ? row?.itemName : "NA"}</Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </StyledTableCell>
                                                                                <StyledTableCell isBordered align='center'>
                                                                                    <CommonTextField
                                                                                        width={"80px"}
                                                                                        type="number"
                                                                                        name="quantity"
                                                                                        value={row?.quantity}
                                                                                        placeholder="Ex. 10"
                                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                        onChange={(e) => {
                                                                                            const data = allItemsList.find((i) => i._id === row.id);
                                                                                            const finalValue =
                                                                                                data && +e?.target?.value > data.productQuantity
                                                                                                    ? data.productQuantity
                                                                                                    : +e?.target?.value;
                                                                                            // console.log(data)
                                                                                            if (+e?.target?.value >= 0) {
                                                                                                handleChangeForItems(index, finalValue, "quantity")
                                                                                            } else {
                                                                                                return;
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </StyledTableCell>
                                                                                <StyledTableCell isBordered >
                                                                                    <Box display={'flex'} justifyContent={"center"}>
                                                                                        {invoiceData?.unit?.unit &&
                                                                                            <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "30px", minHeight: "25px" }}>
                                                                                                {invoiceData?.unit?.unit}
                                                                                            </Box>
                                                                                        }
                                                                                    </Box>
                                                                                </StyledTableCell>
                                                                                <StyledTableCell isBordered align='center'>
                                                                                    <CommonTextField
                                                                                        isCurrency
                                                                                        currencyValue={invoiceData?.currency?.symbol}
                                                                                        width={"80px"}
                                                                                        type="number"
                                                                                        name="ratePerUnit"
                                                                                        value={row?.ratePerUnit}
                                                                                        placeholder="Ex.10"
                                                                                        onChange={(e) => {
                                                                                            if (+e?.target?.value >= 0) {
                                                                                                handleChangeForItems(index, e.target.value, "ratePerUnit")
                                                                                                handleAdvanceLicenseChange(index, { rate: e.target.value })
                                                                                            } else {
                                                                                                return;
                                                                                            }
                                                                                        }}
                                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" }, "& .mui-135eaf6-MuiInputBase-root-MuiOutlinedInput-root": { paddingLeft: "6px" } }}
                                                                                    />
                                                                                </StyledTableCell>
                                                                                <StyledTableCell isBordered align='center'>
                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                        <Box sx={{ bgcolor: theme.palette.lightPrimary.main, color: theme.palette.primary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                                            <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>{invoiceData?.currency?.symbol} {row?.subTotal || 0}</Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </StyledTableCell>
                                                                                <StyledTableCell isBordered align='center' >
                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                        <IconBackground icon={"delete"} onClick={() => handleDeleteItem(index)} />
                                                                                    </Box>
                                                                                </StyledTableCell>
                                                                                {isAdvanceLicense && <StyledTableCell isBordered align='center'>
                                                                                    <CommonTextField
                                                                                        width={"80px"}
                                                                                        type="number"
                                                                                        name="quantity"
                                                                                        value={
                                                                                            selectedRows.find(item => item.index === index)?.advanceLicenseQuantity || ""
                                                                                        }
                                                                                        placeholder="Ex. 10"
                                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                        onChange={(e) => {
                                                                                            const selectedRow = selectedRows.find(item => item.index === index);
                                                                                            // console.log(selectedRow?.id)
                                                                                            const data = purchaseOrderListData.find((i) => i.id === selectedRow?.id);
                                                                                            if (+e?.target?.value < 0) return; 
                                                                                            const finalValue =
                                                                                                data && +e?.target?.value > data.quantity
                                                                                                    ? data.quantity
                                                                                                    : +e?.target?.value;
                                                                                            if (+e?.target?.value >= 0) {
                                                                                                handleAdvanceLicenseChange(index, { quantity: finalValue })
                                                                                            } else {
                                                                                                return;
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </StyledTableCell>}
                                                                                {isAdvanceLicense && <StyledTableCell isBordered align='center'>
                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                        <Box sx={{ bgcolor: theme.palette.lightPrimary.main, color: theme.palette.primary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                                            <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>{invoiceData?.currency?.symbol}{selectedRows.find(item => item.index === index)?.advanceLicensePrice || 0}</Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </StyledTableCell>}
                                                                            </StyledTableRow>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <StyledTableRow isBordered sx={{ backgroundColor: "transparent !important" }}>
                                                                    <StyledTableCell isBordered></StyledTableCell>
                                                                    <StyledTableCell isBordered sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.lightPrimary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                            <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>
                                                                                {invoiceData?.totalQuantity || 0}
                                                                            </Typography>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered></StyledTableCell>
                                                                    <StyledTableCell isBordered sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.lightPrimary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                            <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>
                                                                                {invoiceData?.currency?.symbol}{invoiceData?.subTotal || 0}
                                                                            </Typography>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered></StyledTableCell>
                                                                    <StyledTableCell isBordered></StyledTableCell>
                                                                    {isAdvanceLicense && <StyledTableCell isBordered></StyledTableCell>}
                                                                    {isAdvanceLicense && <StyledTableCell isBordered></StyledTableCell>}
                                                                    {isAdvanceLicense && <StyledTableCell isBordered></StyledTableCell>}
                                                                </StyledTableRow>
                                                            </>
                                                            :
                                                            <StyledTableRow>
                                                                <StyledTableCell colSpan={12}>
                                                                    <NoDataFound />
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 2 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Packing charge"
                                            name="packingCharge"
                                            value={invoiceData?.packingCharge}
                                            placeholder="Enter The Packing charge"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("packingCharge", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Insurance"
                                            name="Insurance"
                                            value={invoiceData?.Insurance}
                                            placeholder="Enter The Insurance"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("Insurance", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Other charge"
                                            name="otherCharge"
                                            value={invoiceData?.otherCharge}
                                            placeholder="Enter The Other charge"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("otherCharge", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <CommonTextField
                                            type="text"
                                            multiline
                                            rows={4}
                                            label="Customer Details"
                                            name="customerDetails"
                                            value={invoiceData?.customerDetails}
                                            placeholder="Provide additional details (e.g., contact information)"
                                            onChange={(e) => handleChange("customerDetails", e.target.value)}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12} display={"flex"} gap={2}>
                                {value != 0 &&
                                    <Button className={classes.cancelButton} onClick={() => handleUpdatePreviousValue()} disabled={value == 0}>{activeTab?.value == 0 ? "Cancel" : "Previous"}</Button>
                                }
                                <Button className={classes.saveButton} onClick={() => handleUpdateNextValue()}>{activeTab?.value == 2 ? "Create Invoice" : "Save &  Next"}</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

            </Grid>
        </Box>
    )
}

export default AddUpdateInvoice